import { useMemo } from 'react';
import type { List } from '@gonfalon/immutable-shim/immutableShim';
import { isImmutable } from '@gonfalon/immutable-shim/immutableShim';

import { RolloutInstructionDescription } from '#components/automated-rollouts/guarded-rollouts/review-save';
import type { Variation as FlagVariation } from '#utils/flags/records/Variation';
import type { MeasuredRolloutSemanticInstructionV2 } from '#utils/instructions/shared/types';

interface Props {
  semanticInstruction: MeasuredRolloutSemanticInstructionV2;
  variations: List<FlagVariation>;
}

export const MeasuredRolloutRuleInstructionDescription = ({ semanticInstruction, variations }: Props) => {
  const metrics = useMemo(() => {
    return isImmutable(semanticInstruction?.metrics)
      ? semanticInstruction?.metrics?.toJS()
      : semanticInstruction?.metrics;
  }, [semanticInstruction?.metrics]);

  const stages = isImmutable(semanticInstruction?.stages)
    ? semanticInstruction?.stages?.toJS()
    : semanticInstruction?.stages;

  // Add final 100% stage with no duration, this helps with rendering
  // the instruction to show the final percentage.
  const processedStages = stages ? [...stages, { rolloutWeight: 100000 }] : stages;

  const variationsArray = isImmutable(variations) ? variations.toJS() : variations;

  return (
    <RolloutInstructionDescription
      originalVariationId={semanticInstruction.controlVariationId}
      targetVariationId={semanticInstruction.testVariationId}
      rolloutContextKind={semanticInstruction.randomizationUnit}
      variations={variationsArray}
      metrics={metrics}
      stages={processedStages}
    />
  );
};
